import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import { AuthStore } from '@/store/auth.store';
import { APP_ROUTES } from '@/routes/routes.type';
import { InfoPagesService } from '@/services/info-pages/info-pages.service';
import { BlogNavStore } from '@/store/blog-nav.store';

@Component({
  selector: 'app-footer',
  imports: [RouterLink, LucideAngularModule],
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  readonly authStore = inject(AuthStore);
  readonly infoPages = inject(InfoPagesService);
  readonly blogNavStore = inject(BlogNavStore);

  readonly routes = {
    home: '/',
    questionnaire: `/${APP_ROUTES.QUESTIONNAIRE}/1`,
    dailyReflection: `/${APP_ROUTES.DAILY_REFLECTION}`,
    history: `/${APP_ROUTES.HISTORY}`,
    reference: `/${APP_ROUTES.REFERENCE}`,
    blog: `/${APP_ROUTES.BLOG}`,
    login: `/${APP_ROUTES.LOGIN}`,
    register: `/${APP_ROUTES.REGISTER}`,
  } as const;

  readonly infoPageRoute = APP_ROUTES.INFO_PAGE.split('/:')[0];

  constructor() {
    this.infoPages.loadGroups();
  }
}
